import $ from 'jquery';
import { _ } from 'core-js';

export default class StaticArticle {
  constructor(section) {
    const el = section.el;
    this.$articleWrapper = $('[data-article-wrapper]', el);
    this.$articleImage = $('[data-article-image]', el);

    this._positionImage();

    $(window).on('resize.article', () => this._positionImage());
  }

  onSectionMessage(name) {
    if (name === 'header:repositionedNav') {
      this._positionImage();
    }
  }

  _positionImage() {
    this.$articleImage
      .css('top', this.$articleWrapper.offset().top)
      .addClass('article-image-positioned');
  }

  onSectionUnload() {
    $(window).off('resize.article');
  }
}
